module.exports = __webpack_public_path__ + "img/Logo-Fiesp.baf73d9c.jpg";